import Vue from 'vue'
import Vuex from 'vuex'
import { clearSavedStore, readSavedStore, saveStoreState } from './persist'

Vue.use(Vuex)

// 2026-10-05：这里只检查本地令牌是否存在，不把前端判断当成服务端验签。
// 例如旧记录只有 token、用户资料暂时缺失时，仍可通过登录检查接口恢复资料。
export function hasLoginToken(state) {
  return !!state && state.isLogin === true && typeof state.token === 'string' && state.token.trim() !== ''
}

// 2026-10-05：业务页面还需要完整的用户资料，避免读取 null.username / null.admin_level 白屏。
// MySQL 返回的 id、管理员等级可能是数字字符串；等级为 0 也是合法资料，不能误判为未登录。
export function hasUsableLoginState(state) {
  if (!hasLoginToken(state)) return false
  const user = state.user
  return !!user && typeof user === 'object' && !Array.isArray(user) &&
    (typeof user.id === 'number' || typeof user.id === 'string') &&
    Number.isInteger(Number(user.id)) && Number(user.id) > 0 &&
    typeof user.username === 'string' && user.username.trim() !== '' &&
    (typeof user.admin_level === 'number' || typeof user.admin_level === 'string') && String(user.admin_level).trim() !== '' &&
    Number.isInteger(Number(user.admin_level))
}

const defaultState = () => ({
  //是否登录 默认未登录
  isLogin: false,
  token: null,
  user: null,
})

export default new Vuex.Store({
  state: Object.assign(defaultState(), readSavedStore() || {}),
  mutations: {
    login(state,r){
      state.isLogin = true;
      state.token = r.msg;
      state.user = r.data
      saveStoreState(state)
    },
    logout(state){
        clearSavedStore();
        Vue.set(state,'isLogin',false)
        Vue.set(state,'token',null)
        Vue.set(state,'user',null)
    },
  },
  actions: {
  },
  getters:{
    // 2026-10-05：有效令牌和可供页面读取的资料都齐全，才允许进入业务页面。
    getLoginState: (state) => {
      return hasUsableLoginState(state);
    },
  },
  modules: {
  }
})
